import React from "react"

export default function Error404() {
  return <div>Page Not Found</div>
}



// WEBPACK FOOTER //
// ./src/routes/errors/Error404.jsx